var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAndroid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4645 9.55493L9.59031 10.321L5.21924 14.8081L11.8851 10.9777L10.7924 9.88326L10.4645 9.55493Z",
    fill: "#43B02A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2887 9.22663C14.0701 9.11719 12.4309 8.13221 12.1031 7.91333L11.0103 9.00775L10.5732 9.44551L10.9011 9.77384L11.9938 10.8683L14.1794 9.55496C14.2887 9.55496 14.2887 9.44551 14.2887 9.33607C14.3979 9.33607 14.2887 9.33607 14.2887 9.22663Z",
    fill: "#43B02A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7924 9.00771L11.8851 7.91329L9.04393 6.27167L5.21924 3.97339L10.4645 9.22659L10.7924 9.00771Z",
    fill: "#43B02A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3548 9.44572L9.37127 8.3513L4.78164 3.97363C4.67236 3.97363 4.67236 4.08307 4.67236 4.19252V14.8084V14.9178L9.15271 10.5401L10.3548 9.44572Z",
    fill: "#43B02A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9283 18.2007H3.14286C1.83154 18.2007 0.73877 17.1063 0.73877 15.793V2.98829C0.73877 1.67498 1.83154 0.580566 3.14286 0.580566H15.9283C17.2396 0.580566 18.3323 1.67498 18.3323 2.98829V15.793C18.3323 17.2157 17.3489 18.2007 15.9283 18.2007ZM3.14286 1.01833C2.05009 1.01833 1.17588 1.89387 1.17588 2.98829V15.793C1.17588 16.8874 2.05009 17.7629 3.14286 17.7629H15.9283C17.021 17.7629 17.8952 16.8874 17.8952 15.793V2.98829C17.8952 1.89387 17.021 1.01833 15.9283 1.01833H3.14286Z",
    fill: "#43B02A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.20665fb35e9f056bd6a2c6ac60e8136d.svg";
export { ForwardRef as ReactComponent };